import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { Button, Table } from "react-bootstrap";
import { CSVLink } from "react-csv";
import { FaFilter } from "react-icons/fa";
import moment from "moment";
import Constants from "../../../util/Constants";
import DailySalesReportAPI from "../../../api/DailySalesReportAPI";
import StackedChartComponent from "../chartComponent/MultiBarChart";
import FilterComplexPannel from "../../filter/FilterComplexPannel";
import ApiUiController from "../../../controller/ApiUiController";

class LeadToSiteVisitRatioMonthWise extends React.Component {
  constructor(props) {
    super(props);
    const model = reactLocalStorage.getObject(Constants.Model);
    const userOptions = model.user.options || [];
    const monthOptions = Constants.Months || [];
    this.lead = model.lead;
    this.meeting = model.meeting;
    const leadFields = model.lead.fields;
    const leadKeys = Object.keys(leadFields).filter((key) => ["enquiry_date", "responsible_person"].includes(key));
    this.lFields = {};
    leadKeys.map((key) => this.lFields[key] = leadFields[key]);
    this.lead.fields = this.lFields;
    this.loggedInUserId = reactLocalStorage.getObject(Constants.LoggedInUser).user_id;
    this.state = {
      progressData: [],
      userOptions,
      monthOptions,
      filters: [{
        field: "responsible_person",
        condition: "in",
        value: `~${this.loggedInUserId}~`,
        model_key: 'lead'
      }, {
        field: "enquiry_date",
        condition: "in",
        value: `${moment.utc().startOf('year').format('YYYY-MM-DDTHH:mm:ss.SSSZ')} ~ ${moment.utc().endOf('year').format('YYYY-MM-DDTHH:mm:ss.SSSZ')}`,
        model_key: 'lead'
      }],
      tableData: [],
      series: [],
      inApiCall: false,
      isFilterOpen: true,
      exportData: [],
    };
  }

  componentDidMount() {
    this.fetchApi(this.state.filters, this.onSuccess, this.onFail);
  }

  fetchApi = (filters, onSuccess, onFail) => {
    const body = {
      filters: filters,
      modelx: "lead_model",
      modely: "meeting_model",
      x: "l.enquiry_date",
      y: "l.last_meeting_date",
      z: "l.id",
      a: 'l.responsible_person',
      b: 'mt.responsible_person'
    };
    this.setState({ inApiCall: true });
    DailySalesReportAPI.LeadSiteVisitReportMonthWiseRatio(body, onSuccess, onFail);
  };

  onSuccess = (data) => {
    const { tableData, series } = this.parseData(data);
    const exportData = tableData;
    this.setState({ tableData, series, exportData, inApiCall: false });
  };

  onFail = (err) => {
    console.log("Failed to fetch data", err);
  };


  parseData = (response) => {
    // Prepare table data for each month
    const tableData = this.state.monthOptions.map((monthOption) => {
      const monthNo = parseInt(monthOption.value);
      let leads = 0;
      let meetings = 0;

      response.forEach((item) => {
        const leadMonth = new Date(item.enquiry_date).getMonth() + 1;
        const meetingMonth = item.last_meeting_date ? new Date(item.last_meeting_date).getMonth() + 1 : null;

        if (leadMonth === monthNo) leads += 1;
        if (meetingMonth === monthNo) meetings += 1;
      });

      return {
        month: monthOption.label,
        leads,
        meetings,
      };
    });

    // Prepare chart series
    const series = [
      { name: "Leads", data: tableData.map((row) => row.leads) },
      { name: "Site Visit", data: tableData.map((row) => row.meetings) },
    ];
    return { tableData, series };
  };

  toggleFilter = () => {
    this.setState((prevState) => ({
      isFilterOpen: !prevState.isFilterOpen,
    }));
  };

  onFilterChange = (updatedFilters) => {
    this.setState({ filters: updatedFilters },
      this.fetchApi(this.state.filters, this.onSuccess, this.onFail));
  };

  render() {
    const { exportData, filters, isFilterOpen, inApiCall, userOptions, tableData, series } = this.state;
    let selectedUserId, filteredUserOptions;
    filters.map(filter => filter.field === 'responsible_person' ? selectedUserId = filter.value.split(Constants.Opt).filter(Boolean) : null);
    filteredUserOptions = userOptions.filter(user => {
      if (Boolean(selectedUserId)) {
        return selectedUserId?.some(id => parseInt(id) === user.value);
      }
      return true;
    });
    const totalLeads = tableData.reduce((sum, row) => sum + row.leads, 0);
    const totalMeetings = tableData.reduce((sum, row) => sum + row.meetings, 0);
    const totalPercentage = ((totalMeetings / totalLeads) * 100 || 0).toFixed(2);

    const table = (
      <Table bordered hover>
        <thead>
          <tr>
            <th>Months</th>
            <th>Leads</th>
            <th>Site Visit</th>
            <th>Percentage(%)</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, index) => (
            <tr key={index}>
              <td>{row.month}</td>
              <td>{row.leads}</td>
              <td>{row.meetings}</td>
              <td>{((row.meetings / row.leads) * 100 || 0).toFixed(2)}%</td>
            </tr>
          ))}
          {/* Add total row */}
          <tr>
            <td><strong>Total</strong></td>
            <td><strong>{totalLeads}</strong></td>
            <td><strong>{totalMeetings}</strong></td>
            <td><strong>{totalPercentage}%</strong></td>
          </tr>
        </tbody>
      </Table>
    );


    return (
      <ApiUiController inApiCall={inApiCall}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-7">
                  <h1>Lead To Meeting Ratio (Month Wise)</h1>
                </div>
                <div className="col-md-5">
                  <CSVLink
                    data={exportData} filename={`lead_to_site _Visit_ratio_monthWise_report.csv`}>
                    <Button className="buttons btn-success">Export</Button>
                  </CSVLink>
                </div>
              </div>
            </div>
            <div className="col-md-4 pt-1">
              <div className="row filterrow">
                <div className="col-md-12 lastcol">
                  <div className="m-right">
                    <div className="btn btn-lead btn-sm filter-button" onClick={this.toggleFilter}>
                      <FaFilter />
                      <span className="badge badge-danger badge-mini rounded-circle">
                        {this.state.filters.length}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row pt-3">
            <div className="container-fluid">
              <div className="row">
                <div className={`col-md-${isFilterOpen ? 9 : 12}`}>
                  <StackedChartComponent progressOptions={this.state.monthOptions} progressSums={series} type={"multiBar"} />
                  <div className="col-md-12">{table}</div>
                </div>
                {this.state.isFilterOpen && (
                  <FilterComplexPannel
                    filters={filters}
                    modelX={this.lead}
                    modelY={this.meeting}
                    onFilterChange={this.onFilterChange}
                    isFilterOpen={this.state.isFilterOpen}
                    restrict={this.Restrict}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </ApiUiController>
    );
  }
}



export default LeadToSiteVisitRatioMonthWise;
